module.exports = __webpack_public_path__ + "css/fonts.woff.css";